import { Component, Input } from '@angular/core';
import { ICamp } from '../../model/camp.model';
import {
  getCampAlertMessages,
  getCampLieuAddress,
  getValidationStatus
} from '../../util/camp-utils';
import { getAdherentQualificationLabel } from '../../util/adherent-utils';
import { getDdcAdherentStaffRoleIcon } from '../../util/adherent-utils';
import { convertToHumanDate, getAgeAdherentAuDebutCamp } from '../../util/moment.utils';
import { PARAMETRES_AVIS_SGDF } from '../../constant/constant';
import { ICampAvis } from '../../model/camp-avis.model';
import { TypeAvisEnum } from '../../constant/enum';
import { IAdherentInformations } from '../../model/adherent-informations.model';

@Component({
    selector: 'ddc-camp-details-card',
    templateUrl: './camp-details-card.component.html',
    styleUrls: ['./camp-details-card.component.scss'],
    standalone: false
})
export class CampDetailsCardComponent {

  @Input() set campWithDetails(campWithDetails: ICamp) {
    this._campWithDetails = campWithDetails;
    this.initAdherentsInformations(campWithDetails);
  }

  getCampAlertMessages = getCampAlertMessages;
  getCampLieuAddress = getCampLieuAddress;
  getValidationStatus = getValidationStatus;
  getDdcAdherentStaffRoleIcon = getDdcAdherentStaffRoleIcon;
  getAdherentQualificationLabel = getAdherentQualificationLabel;
  convertToHumanDate = convertToHumanDate;
  getAgeAdherentAuDebutCamp = getAgeAdherentAuDebutCamp;

  PARAMETRES_AVIS_SGDF = PARAMETRES_AVIS_SGDF;

  _campWithDetails: ICamp;
  adherentsInformations;

  constructor() {
  }

  getCampAvisByType(campAvis: ICampAvis[], typeAvis: TypeAvisEnum) {
    if (campAvis && campAvis.length > 0) {
      return campAvis.find((avis: ICampAvis) => avis.typeAvis == typeAvis);
    }
    return null;
  }

  initAdherentsInformations(camp: ICamp) {
    let adherentsInformations = {};
    if(camp && camp.campAdherentStaffsInformations && camp.campAdherentStaffsInformations.length > 0) {
      camp.campAdherentStaffsInformations.forEach((campAdherentInformations:IAdherentInformations) => {
        adherentsInformations[campAdherentInformations.numero] = campAdherentInformations;
      });
    }
    this.adherentsInformations = adherentsInformations;
  }


}
